import { queryOptions } from '@tanstack/react-query';
import { cmsQueryKeys } from '../cms/cmsQueryKeys';
import { getGlobals } from '../cms/getGlobals';
import { GLOBAL_KEYS } from '../cms/getGlobals/schemas';

export const alertBannerQueryOptions = queryOptions({
  queryKey: [...cmsQueryKeys.getGlobals, GLOBAL_KEYS.ALERT_BANNERS],
  queryFn: () => getGlobals(GLOBAL_KEYS.ALERT_BANNERS),
  staleTime: Infinity,
});
